import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _map from "lodash/map";
import _isEqual from "lodash/isEqual";
import _fromPairs from "lodash/fromPairs";
import './index.scss';
import React, { Fragment, PureComponent } from 'react';
import ReactResizeDetector from 'react-resize-detector';
import computeStickyState from './computeStickyState';
import { jsx as ___EmotionJSX } from "@emotion/react";
export default class StickyHeadings extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "containerElement", void 0);
    _defineProperty(this, "contentElements", void 0);
    _defineProperty(this, "headerElements", void 0);
    _defineProperty(this, "scrollHeight", 0);
    _defineProperty(this, "itemStates", []);
    this.computeStickyState = this.computeStickyState.bind(this);
    this.containerElement = null;
    this.headerElements = {};
    this.contentElements = {};
    this.state = {
      bottomPadding: 0,
      headerShiftings: _fromPairs(props.items.map(_ref => {
        let {
          key
        } = _ref;
        return [key, 0];
      })),
      scrollToHeaders: _fromPairs(props.items.map(_ref2 => {
        let {
          key
        } = _ref2;
        return [key, 0];
      }))
    };
  }
  componentDidMount() {
    this.computeStickyState();
  }
  componentDidUpdate() {
    this.computeStickyState();
  }
  onClickTitle(key) {
    const refsAreDefined = k => this.containerElement && this.headerElements[k];
    if (!refsAreDefined(key)) {
      return;
    }
    this.containerElement.scrollTop = this.state.scrollToHeaders[key];
  }
  getNewStickyItemStates(items, scrollHeight) {
    if (scrollHeight === this.scrollHeight && items.length === this.itemStates.length) {
      return this.itemStates;
    }
    this.scrollHeight = scrollHeight;
    this.itemStates = _map(items, _ref3 => {
      let {
        key
      } = _ref3;
      const headerElement = this.headerElements[key];
      const contentElement = this.contentElements[key];
      if (!headerElement || !contentElement) {
        return {
          contentHeight: 0,
          headerHeight: 0,
          key
        };
      }
      const {
        height: headerHeight
      } = headerElement.getBoundingClientRect();
      const {
        height: contentHeight
      } = contentElement.getBoundingClientRect();
      return {
        contentHeight,
        headerHeight,
        key
      };
    });
    return this.itemStates;
  }
  computeStickyState() {
    const {
      disabled,
      items
    } = this.props;
    if (disabled || !this.containerElement) {
      return;
    }
    const {
      height: containerHeight
    } = this.containerElement.getBoundingClientRect();
    const {
      scrollHeight,
      scrollTop
    } = this.containerElement;
    const newState = computeStickyState({
      containerHeight,
      items: this.getNewStickyItemStates(items, scrollHeight),
      scrollTop
    });
    if (!_isEqual(newState, this.state)) {
      this.setState(newState);
    }
  }
  render() {
    const {
      items
    } = this.props;
    const {
      bottomPadding,
      headerShiftings
    } = this.state;
    return ___EmotionJSX("div", {
      className: "le-shared-sticky-container dc-u-wh-100pc dc-u-of-auto",
      onScroll: this.computeStickyState,
      ref: el => {
        this.containerElement = el;
      }
    }, ___EmotionJSX(ReactResizeDetector, {
      handleHeight: true,
      onResize: this.computeStickyState,
      skipOnMount: true
    }), items.map(_ref4 => {
      let {
        content,
        header,
        key
      } = _ref4;
      return ___EmotionJSX(Fragment, {
        key: key
      }, ___EmotionJSX("div", {
        className: "le-shared-sticky-header dc-u-pos-relative clearfix",
        onClick: () => this.onClickTitle(key),
        onKeyPress: undefined,
        ref: el => {
          this.headerElements[key] = el;
        },
        role: "button",
        style: {
          transform: "translate(0, ".concat(headerShiftings[key], "px)")
        }
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message
        ,
        tabIndex: "-1"
      }, header), ___EmotionJSX("div", {
        ref: el => {
          this.contentElements[key] = el;
        }
      }, content));
    }), this.props.padBottom !== false && ___EmotionJSX("div", {
      className: "dc-u-w-0",
      style: {
        height: bottomPadding
      }
    }));
  }
}